/**
 * Mock PubSub Metadata Storage
 * Simulates XMPP PubSub nodes for admin metadata
 */
import { PubSubAdapter } from '../adapters/pubsub-adapter';
// ============================================================================
// Mock PubSub Metadata API
// ============================================================================
export class MockPubSubMetadata {
    constructor(storage) {
        this.storage = storage;
        this.adapter = new PubSubAdapter(storage);
    }
    // ==========================================================================
    // Force Metadata
    // ==========================================================================
    async getForceMetadata(groupName) {
        return await this.adapter.getForceMetadata(groupName);
    }
    async setForceMetadata(groupName, metadata) {
        await this.adapter.setForceMetadata(groupName, metadata);
    }
    async deleteForceMetadata(groupName) {
        await this.adapter.deleteForceMetadata(groupName);
    }
    // ==========================================================================
    // Room Metadata
    // ==========================================================================
    async getRoomMetadata(roomName) {
        return await this.adapter.getRoomMetadata(roomName);
    }
    async setRoomMetadata(roomName, metadata) {
        await this.adapter.setRoomMetadata(roomName, metadata);
    }
    async deleteRoomMetadata(roomName) {
        await this.adapter.deleteRoomMetadata(roomName);
    }
    // ==========================================================================
    // Game Overview
    // ==========================================================================
    async getGameOverview() {
        return await this.storage.getItem('entities/game-overview');
    }
    async setGameOverview(overview) {
        await this.storage.setItem('entities/game-overview', overview);
    }
    async deleteGameOverview() {
        await this.storage.removeItem('entities/game-overview');
    }
}
//# sourceMappingURL=pubsub-metadata.js.map